import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import imageCompression from "browser-image-compression"; // ref: limit of https://cloud.tencent.com/document/product/867/44987
var SIZE_MB_LIMIT = 2.5;
var WIDTH_LIMIT = 2000;
var isOverTencentLimit = /*#__PURE__*/ function () { var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(file) { return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0: return _context.abrupt("return", new Promise(function (resolve, reject) { var reader = new FileReader(); reader.onload = function () { var image = new Image(); image.onload = function () { var width = image.width; resolve(width > WIDTH_LIMIT || file.size > SIZE_MB_LIMIT * 1024 * 1024); }; image.onerror = function () { reject(new Error("Unable to load image")); }; image.src = reader.result; }; reader.onerror = function () { reject(new Error("Unable to read file")); }; reader.readAsDataURL(file); }));
        case 1:
        case "end": return _context.stop();
    }
} }, _callee); })); return function isOverTencentLimit(_x) { return _ref.apply(this, arguments); }; }();
function converHeictImg(_x2) { return _converHeictImg.apply(this, arguments); }
function _converHeictImg() { _converHeictImg = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(imageFile) { var heic2any, jpgImage; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
    switch (_context2.prev = _context2.next) {
        case 0:
            _context2.next = 2;
            return import("heic2any");
        case 2:
            heic2any = _context2.sent.default;
            if (!(imageFile.type.toLowerCase() !== "image/heic")) {
                _context2.next = 5;
                break;
            }
            return _context2.abrupt("return", imageFile);
        case 5:
            _context2.next = 7;
            return heic2any({ blob: imageFile, toType: "image/jpg", quality: 1 });
        case 7:
            jpgImage = _context2.sent;
            return _context2.abrupt("return", new File([jpgImage], imageFile.name.split("")[0] + ".jpeg", { type: "image/jpeg" }));
        case 9:
        case "end": return _context2.stop();
    }
} }, _callee2); })); return _converHeictImg.apply(this, arguments); }
export function compressImage(_x3) { return _compressImage.apply(this, arguments); }
function _compressImage() { _compressImage = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(imageFile) { var image, compressedFile; return _regeneratorRuntime.wrap(function _callee3$(_context3) { while (1) {
    switch (_context3.prev = _context3.next) {
        case 0:
            _context3.next = 2;
            return converHeictImg(imageFile);
        case 2:
            image = _context3.sent;
            _context3.next = 5;
            return isOverTencentLimit(image);
        case 5:
            if (_context3.sent) {
                _context3.next = 7;
                break;
            }
            return _context3.abrupt("return", image);
        case 7:
            _context3.next = 9;
            return imageCompression(image, { maxSizeMB: SIZE_MB_LIMIT, maxWidthOrHeight: WIDTH_LIMIT, useWebWorker: true });
        case 9:
            compressedFile = _context3.sent;
            return _context3.abrupt("return", new File([compressedFile], imageFile.name.split("")[0] + ".jpeg", { type: "image/jpeg" }));
        case 11:
        case "end": return _context3.stop();
    }
} }, _callee3); })); return _compressImage.apply(this, arguments); }
export default compressImage;
